import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { BaseService } from './base-service';
import { UserService } from './user-service';

import { API_TIMEOUT } from './config';

@Injectable()
export class PreferencesService extends BaseService {
  data = null;

  constructor(public http: Http, public userService: UserService) {
    super();
    console.log('Hello PreferencesService Provider');
  }

  load() {
    if (this.data) {
      // already loaded data
      return this.data;
    }
    const userId = this.userService.authData.userId;
    const url = `${super.url()}/users/${userId}/preferences`;
    const headers = { headers: this.userService.getAuthorizationHeaders() };
    return this.http.get(url, headers)
      .timeout(API_TIMEOUT)
      .map(this.extractData)
      .catch(this.handleError);
  }

  update() {
    const userId = this.userService.authData.userId;
    const url = `${super.url()}/users/${userId}/preferences`;
    const params = { preferences: this.data };
    const headers = { headers: this.userService.getAuthorizationHeaders() };
    this.data.updatedAt = Date.now();
    return this.http.put(url, params, headers)
      .timeout(API_TIMEOUT)
      .map(this.extractData)
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/preferences-service.ts